var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ChartContainer"},[_c('canvas',{ref:"lineChart",attrs:{"id":"myChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }